<template>
  <div class="search-page">
    <div class="search-input-wrapper">
      <div class="search-wrapper">
        <img class="search-btn" src="/static/img/search.png" alt>
        <input class="search-input" type="text" placeholder="关键字搜索">
      </div>
      <div class="nav-wrapper">
        <span>当前位置：</span>
        <span class="active" @click="toPage({name:'Search'})">搜索</span>
      </div>
    </div>
    <div class="search-list">
      <list-item v-for="item in newList" :key="'new'+item.id" :itemData="item" @toPage="getDetail"></list-item>
    </div>
    <div>
      <model-page :dataObj="ariList" @nextPage="nextPage"></model-page>
    </div>
  </div>
</template>
<script>
import listItem from "@/components/views/common/listItem.vue";
import ModelPage from "@/components/views/common/ModelPage";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      ariList: [], //分页所需的值
      newList: [],
      page: 1,
      count: 10
    };
  },
  mounted() {
    this.getNewList();
  },
  methods: {
        toPage(url) {
      this.$router.push(url);
    },
    getNewList() {
      const params = {
        type: 1,
        page: this.page,
        count: this.count
      };
      userApi.getnewList(params).then(res => {
        this.ariList = res.data;
        this.newList = res.data.list;
      });
    },
    nextPage(pageNo) {
      this.page = pageNo;
      this.getNewList();
    },
    getDetail(id) {
      this.$router.push({
        name: "searchDetail",
        query: {
          id: id
        }
      });
    }
  },
  components: {
    listItem,
    ModelPage
  }
};
</script>
<style scoped>
.search-list {
  margin-top: 30px;
  width: 100%;
  border-width: 20px 1px 1px 1px;
  border-style: solid;
  border-color: #e6ecf2;
  padding: 40px 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 10px;
}
.search-page {
  width: 1230px;
  margin: 0 auto 30px;
}
.search-input-wrapper {
  display: flex;
}
.search-wrapper {
  width: 310px;
  margin-right: 30px;
  height: 40px;
  background: rgba(237, 241, 244, 1);
  border: 1px solid rgba(220, 227, 233, 1);
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
}
.search-btn {
  width: 25px;
  height: 26px;
  position: absolute;
  top: 7px;
  right: 10px;
  cursor: pointer;
}
.search-input::placeholder {
  color: #a2a8b8;
}
.search-input {
  width: 100%;
  height: 100%;
  padding: 10px 60px 10px 20px;
  box-sizing: border-box;
  outline: none;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  color: #333;
  background: rgba(237, 241, 244, 1);
}
.nav-wrapper {
  flex: 1;
}
.nav-wrapper {
  font-size: 0;
  margin-bottom: 30px;
}
.nav-wrapper span {
  font-size: 16px;
  color: #212121;
  line-height: 40px;
}
.active {
  color: #194eb0 !important;
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/views/Search/index.vue